export default [
    {
        path: 'isle-save',
        component: () => import('@/pages/isle/game/isle-save')
    },
    {
        path: 'isle-person',
        component: () => import('@/pages/isle/game/isle-person')
    }
];